import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { Batch } from '../../../constants';
import { BatchDetailsComponent } from '../batch-details/batch-details.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-completed-batches',
  templateUrl: './completed-batches.component.html',
  styleUrls: ['./completed-batches.component.scss'],
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, MessageModule, ButtonModule],
  providers: [DialogService]
})
export class CompletedBatchesComponent implements OnInit {
  completedBatches$!: Observable<Batch[]>;

  constructor(
    private firestoreService: FirebaseFirestoreService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.completedBatches$ = this.firestoreService.getCompletedBatches();
  }

  viewBatchDetails(batch: Batch): void {
    // open batch details modal
    const dialogRef = this.dialogService.open(BatchDetailsComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: {
        batchId: batch.batchId
      }
    });
    dialogRef.onClose.subscribe((confirmed) => {
      if(confirmed) {
        // this.router.navigate(['/batch-details', batch.batchId]);
      }
    });
  }
}
